import {InjectionToken} from '@angular/core';
import {Converter} from '@spartacus/core';
import {B2BDocumentTypeList, InvoiceHistoryList} from '../invoices.model';

export const INVOICES_NORMALIZER = new InjectionToken<Converter<any, B2BDocumentTypeList>>('BillNormalizer');

export const INVOICES_HISTORY_NORMALIZER = new InjectionToken<Converter<any, InvoiceHistoryList>>('BillHistoryNormalizer');
